
<template>
  <full-container v-loading="loading">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form
        ref="ff"
        size="small"
        :inline="true"
        :model="queryParams"
        class="search-form"
      >
        <el-form-item>
          <el-input
            v-model="queryParams.keyWord"
            clearable
            placeholder="单号/客户/备注"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch()">查询</el-button>
        </el-form-item>
      </el-form>
      <el-button @click="onForm()">发布任务</el-button>
    </div>
    <!--表格-->
    <el-table ref="tb" :data="datalist.Items" height="100%" border>
      <el-table-column label="来源" align="center" width="60">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.Target ? 'danger' : 'primary'">
            {{ row.Target ? "线索" : "日常" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="Client"
        label="客户单位"
        min-width="180"
        fixed
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <el-popover placement="top">
            <p>联系地址：{{ row.Address }}</p>
            <p>联系方式：{{ row.Linkman }} {{ row.Linktel }}</p>
            <el-link slot="reference">{{ row.Client }}</el-link>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="Request"
        label="任务内容"
        min-width="150"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <el-popover placement="top">
            <p>工作类别：{{ $utils.meta.format("schedule-type", row.Type) }}</p>
            <p>任务发起：{{ row.Initiator.Name }}</p>
            <p>
              发起时间：
              {{
                $utils.common.parseTime(row.CreateTime, "{y}-{m}-{d} {h}:{i}")
              }}
            </p>
            <el-link slot="reference">{{ row.Request }}</el-link>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="Operator.Name"
        label="负责人"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column label="计划执行时间" min-width="140">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row?.PlanTime, "{y}-{m}-{d} {h}:{i}") }}
        </template>
      </el-table-column>
      <el-table-column label="工作完成时间" min-width="140">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row?.ExecTime, "{y}-{m}-{d} {h}:{i}") }}
        </template>
      </el-table-column>
      <el-table-column
        prop="Result"
        label="工作反馈"
        min-width="150"
        show-overflow-tooltip
      />
      <el-table-column label="状态" min-width="120" align="center">
        <template slot-scope="{ row }">
          <el-link
            size="small"
            :type="
              row.State == -1 ? 'info' : row.State == 0 ? 'primary' : 'default'
            "
            @click="onReview(row)"
          >
            {{ row.StateText }}
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div slot="footer" class="toolbar">
      <el-pagination
        background
        :page-size="datalist.PageSize"
        :current-page="datalist.PageIndex"
        :total="datalist.TotalCount"
        @current-change="onSearch"
      />
    </div>
  </full-container>
</template>
  
  
<script>
import formpage from "./form.vue";
import review from "./_detail.vue";
export default {
  data() {
    return {
      loading: false,
      datalist: {},
      queryParams: {
        index: 1,
        size: 20,
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    // 查询参数
    onSearch(val = 1) {
      this.queryParams.index = val;
      this.loadData();
    },
    // 信息列表
    loadData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$apis.job.schedule
        .list(this.queryParams)
        .then((res) => {
          this.datalist = res;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onReview(row) {
      this.$layer.iframe({
        title: "工作任务",
        area: ["600px", "auto"],
        content: {
          content: review,
          parent: this,
          data: {
            id: row.Id,
          },
        },
      });
    },
    onForm() {
      this.$layer.iframe({
        title: "工作任务",
        area: ["600px", "auto"],
        content: {
          content: formpage,
          parent: this,
        },
      });
    },
  },
};
</script>
    